import React from 'react'
import { classNames } from 'core/helpers/misc'

export const ReadOnlyInput = ({ value, icon, customClassName }) => (
	<div className={classNames({ 'kt-input-icon kt-input-icon--left': !!icon })}>
		<input className={`form-control ${customClassName}`} readOnly value={value} />

		{icon && (
			<span className="icon is-small is-left">
				<i className={icon} />
			</span>
		)}
	</div>
)
